module.exports = __webpack_public_path__ + "img/fail.a94f7b4f.png";